import { render, staticRenderFns } from "./EventsCatalog.vue?vue&type=template&id=1526699b&scoped=true"
import script from "./EventsCatalog.vue?vue&type=script&lang=js"
export * from "./EventsCatalog.vue?vue&type=script&lang=js"
import style0 from "./EventsCatalog.vue?vue&type=style&index=0&id=1526699b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526699b",
  null
  
)

export default component.exports